export type LegalRegion = 'IN' | 'GLOBAL';

const STORAGE_KEY = 'legal-region';
const OVERRIDE_KEY = 'legal-region-override';

export const TERMS_PATHS: Record<LegalRegion, string> = {
  IN: '/legal/terms-of-service-india.txt',
  GLOBAL: '/legal/terms-of-service.txt',
};

export function setLegalRegionOverride(region: LegalRegion) {
  sessionStorage.setItem(OVERRIDE_KEY, region);
  sessionStorage.setItem(STORAGE_KEY, region);
}

export async function resolveLegalRegion(): Promise<LegalRegion> {
  const override = sessionStorage.getItem(OVERRIDE_KEY);
  if (override === 'IN' || override === 'GLOBAL') return override;

  const cached = sessionStorage.getItem(STORAGE_KEY);
  if (cached === 'IN' || cached === 'GLOBAL') return cached;

  const devRegion = import.meta.env.VITE_LEGAL_REGION;
  if (devRegion === 'IN' || devRegion === 'GLOBAL') {
    sessionStorage.setItem(STORAGE_KEY, devRegion);
    return devRegion;
  }

  try {
    const res = await fetch('https://ipapi.co/country/', { signal: AbortSignal.timeout(2000) });
    if (res.ok) {
      const country = (await res.text()).trim();
      const region: LegalRegion = country === 'IN' ? 'IN' : 'GLOBAL';
      sessionStorage.setItem(STORAGE_KEY, region);
      return region;
    }
  } catch {
    // fall through to global default
  }

  sessionStorage.setItem(STORAGE_KEY, 'GLOBAL');
  return 'GLOBAL';
}
